import { AxiosResponse } from 'axios';
import { HttpResponseList } from 'shell/models/http-response';
import { FeatureAuth } from 'shell/models/feature-auth';
import { FeatureAuthClient } from 'system/view-models/feature-auth-list';

export const transformFeatureAuthList = (
  response: AxiosResponse<HttpResponseList<FeatureAuth>>
): Array<FeatureAuthClient> => {
  const data = response.data?.payload?.list || [];

  const res: Array<FeatureAuthClient> = data.map((item: FeatureAuth) => {
    return {
      code: item?.key?.codiceFeature || '',
      description: item?.descrizioneTipoFeature || '',
    };
  });

  return res;
};
